<template>
  <div id="orderItemBaseEdit" class="production-plan-edit" style="margin-bottom:10px">
    <el-card class="box-card">
      <el-row style="margin-top: 10px;">
        <!-- <span class="label">订单号：</span>
                <span class="value" style="width:210px">{{baseData.productionOrderCode?baseData.productionOrderCode:baseData.orderCode}}</span> -->

        <span class="label">工单号：</span>
        <span class="value" style="width:210px">{{ baseData.productionBatchCode }}</span>

        <span class="label" v-if="baseData.childProductionBatchCode">子工单号：</span>
        <span class="value" v-if="baseData.childProductionBatchCode">{{ baseData.childProductionBatchCode }}</span>

        <span class="label">生产数量：</span>
        <span class="value">{{ productionNum }} {{ unitType }}</span>
      </el-row>

      <el-row style="margin-top: 10px;">
        <span class="label">物料编码：</span>
        <span class="value">{{ showMaterialCode ? showMaterialCode : "&nbsp;" }}</span>

        <span class="label">物料名称：</span>
        <span class="value">{{ showMaterialName ? showMaterialName : "&nbsp;" }}</span>

        <span class="label">物料型号：</span>
        <span class="value">{{ showMaterialModel ? showMaterialModel : "&nbsp;" }}</span>

        <span class="label">物料类型：</span>
        <span class="value">{{ showMaterialType ? showMaterialType : "&nbsp;" }}</span>
      </el-row>

      <el-row :gutter="0" style="display: flex;margin-top: 10px;margin-bottom: 10px;">
        <span class="label">计划时间：</span>
        <span style="width:80px;line-height: 32px;font-size:12px">
          {{ allStartTime }}
        </span>
        <span style="padding: 0 10px;"><span style="padding-top: 6px;display: block;text-align: center;">——</span></span>
        <span style="width:80px;line-height: 32px;font-size:12px;margin-left: 10px;">
          {{ allEndTime }}
        </span>
        <!-- <el-button :type="btnTrue" style="margin-left:20px" @click="reSet(true)" v-if="!hasPlanId">顺排</el-button>
                <el-button :type="btnFalse" @click="reSet(false)" v-if="!hasPlanId">倒排</el-button>
                <el-switch style="display: block;margin-left: 60px;margin-top: 7px;margin-right:10px" v-model="showTimeChange" active-color="#13ce66" active-text="联动编排" inactive-text=""></el-switch> -->
        <el-button @click="importPlan" v-if="baseData.splitStatus < 3 && permission.btn_order_batchImportDispatching">导入派工</el-button>
        <el-select style="margin-left: 10px;max-width: 160px;" v-model="factoryModelId" @change="factoryModelChange" clearable filterable popper-class="select_width" placeholder="选择机组">
          <el-option :title="item.name" v-for="item in allWorkershopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-row>

      <el-row>
        <el-row>
          <el-row>
            <el-table class="plan_table" :data="preProductionPlanList" max-height="560" row-key="planId" stripe>
              <el-table-column type="index" width="60" label="序号">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="procedureName" label="工序名称" show-overflow-tooltip min-width="80"></el-table-column>
              <el-table-column prop="productionDateTime" label="计划生产时间" :min-width="W ? 280 : 340">
                <template slot-scope="scope" ref="timedata">
                  <el-row :gutter="0">
                    <el-col :span="W ? 10 : 11">
                      <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width:auto"
                        popper-class="time_picker"
                        format="yyyy-MM-dd HH"
                        size="small"
                        v-model="scope.row.planStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        align="right"
                        @change="setDateStart($event, scope)"
                        :disabled="isDisabled2(scope.row)"
                      ></el-date-picker>
                    </el-col>
                    <el-col :span="W ? 2 : 1"><span style="padding-top: 6px;display: block;text-align: center;">——</span></el-col>
                    <el-col :span="W ? 10 : 11">
                      <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width:auto"
                        size="small"
                        popper-class="time_picker"
                        format="yyyy-MM-dd HH"
                        v-model="scope.row.planEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        align="right"
                        :disabled="isDisabled3(scope.row)"
                        @change="setDateEnd($event, scope)"
                      ></el-date-picker>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="factoryModelId" label="机组" show-overflow-tooltip min-width="100">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.factoryModelId"
                    @visible-change="closeWorkershopSelect($event, scope)"
                    :filter-method="
                      query => {
                        filterWorkershop(query, scope.$index);
                      }
                    "
                    clearable
                    filterable
                    popper-class="select_width"
                    placeholder="机组"
                    :disabled="isDisabled2(scope.row)"
                  >
                    <el-option :title="item.name" v-for="item in workershopList[scope.$index]" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="workerName" label="" :min-width="W ? 56 : 66">
                <template slot-scope="scope">
                  <el-button type="text" :disabled="isDisabled(scope.row) || hasNeedReport(scope.row) || scope.row.updateFlag == 2" @click="addSplit(scope.row, scope.$index)" size="small"
                    >添加执行组</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column prop="workerName" label="执行者 + 设备 + 设备类型 + 加工数量" :min-width="W ? 400 : 330">
                <template slot="header">
                  <span>执行者 + 设备 + 设备类型 + 加工数量</span>
                  <el-tooltip class="item" effect="dark" content="执行者最多显示50名员工，若菜单中找不到该员工，建议通过输入名字的方式检索" placement="top">
                    <span class="help"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-row v-for="(planItem, index) in scope.row.groupList" :key="index" :style="index != 0 ? { marginTop: '10px' } : {}">
                      <el-col :span="5">
                        <el-tooltip v-if="planItem.workerTips" :content="planItem.workerTips" placement="top">
                          <el-select
                            v-model="planItem.workerId"
                            :class="{ redBorder: Number(planItem.unFinishedCount) > 0 || planItem.workerTips }"
                            @visible-change="workerBlur($event, scope.row, index, 'worker')"
                            placeholder="执行人"
                            clearable
                            remote
                            filterable
                            :remote-method="remoteMethod1"
                            :loading="loading"
                            @change="selectWorkerChange($event, scope, index, planItem)"
                            no-data-text="暂无员工"
                            @focus="changeIndex(scope.$index, 1, index)"
                            :disabled="isDisabled(scope.row) || planItem.updateFlag > 0"
                          >
                            <span v-if="planItem && planItem.length == 0" style="padding-left: 20px;font-size: 12px;color: red;line-height: 30px;">暂无员工</span>
                            <el-option v-for="item in planItem.workerSelect || []" :key="item.id" :label="item.label" :value="item.id" :title="item.label">
                              <div :class="{ redText: Number(item.unFinishedCount) > 0 }" :style="showWorkStyle">{{ item.label }}</div>
                              <div :class="{ redText: Number(item.unFinishedCount) > 0 }" style="float:right;width:50px;text-align: right">{{ item.unFinishedCount }}</div>
                            </el-option>
                          </el-select>
                        </el-tooltip>
                        <el-select
                          v-else
                          v-model="planItem.workerId"
                          :class="{ redBorder: Number(planItem.unFinishedCount) > 0 || planItem.workerTips }"
                          @visible-change="workerBlur($event, scope.row, index, 'worker')"
                          placeholder="执行人"
                          clearable
                          remote
                          filterable
                          :remote-method="remoteMethod1"
                          :loading="loading"
                          @change="selectWorkerChange($event, scope, index, planItem)"
                          no-data-text="暂无员工"
                          @focus="changeIndex(scope.$index, 1, index)"
                          :disabled="isDisabled(scope.row) || planItem.updateFlag > 0"
                        >
                          <span v-if="planItem && planItem.length == 0" style="padding-left: 20px;font-size: 12px;color: red;line-height: 30px;">暂无员工</span>
                          <el-option v-for="item in planItem.workerSelect || []" :key="item.id" :label="item.label" :value="item.id" :title="item.label">
                            <div :class="{ redText: Number(item.unFinishedCount) > 0 }" :style="showWorkStyle">{{ item.label }}</div>
                            <div :class="{ redText: Number(item.unFinishedCount) > 0 }" style="float:right;width:50px;text-align: right">{{ item.unFinishedCount }}</div>
                          </el-option>
                        </el-select>
                      </el-col>

                      <el-col :span="7" style="margin-left:4px">
                        <el-tooltip v-if="planItem.deviceTips" :content="planItem.deviceTips" placement="top">
                          <el-select
                            v-model="planItem.deviceId"
                            :class="{ redBorder: Number(planItem.operationRatio) > 1 || planItem.deviceTips }"
                            popper-class="select_width1"
                            clearable
                            @visible-change="deviceBlur($event, scope.row, index, planItem)"
                            remote
                            filterable
                            :remote-method="remoteMethod"
                            :loading="loading"
                            @focus="changeIndex(scope.$index, 1, index)"
                            placeholder="设备"
                            @change="selectDeviceChange($event, scope, index)"
                            :disabled="isDisabled(scope.row) || planItem.updateFlag > 0"
                          >
                            <el-option-group v-for="group in planItem.deviceSelect || []" :key="group.label" :label="group.label">
                              <span v-if="group.deviceList.length == 0" style="padding-left: 20px;font-size: 12px;color: red;line-height: 30px;">暂无常用设备</span>
                              <el-option
                                v-else
                                :title="item.deviceCode + '|' + item.label"
                                v-for="item in group.deviceList"
                                :key="item.id"
                                :label="item.deviceCode + '|' + item.label + ' ' + item.operationRatio"
                                :value="item.id"
                              >
                                <div :class="{ redText: Number(item.operationRatio) > 1 }" style="float:left;width:150px;white-space:nowrap;overflow: hidden;text-overflow: ellipsis;">
                                  {{ item.deviceCode }}|{{ item.label }}
                                </div>
                                <div :class="{ redText: Number(item.operationRatio) > 1 }" style="float:right;width:50px;text-align: right">{{ Math.round(item.operationRatio * 100) }}%</div>
                              </el-option>
                            </el-option-group>
                          </el-select>
                        </el-tooltip>
                        <el-select
                          v-else
                          v-model="planItem.deviceId"
                          :class="{ redBorder: Number(planItem.operationRatio) > 1 || planItem.deviceTips }"
                          popper-class="select_width1"
                          clearable
                          @visible-change="deviceBlur($event, scope.row, index, planItem)"
                          remote
                          filterable
                          :remote-method="remoteMethod"
                          :loading="loading"
                          @focus="changeIndex(scope.$index, 1, index)"
                          placeholder="设备"
                          @change="selectDeviceChange($event, scope, index, planItem)"
                          :disabled="isDisabled(scope.row) || planItem.updateFlag > 0"
                        >
                          <el-option-group v-for="group in planItem.deviceSelect || []" :key="group.label" :label="group.label">
                            <span v-if="group.deviceList.length == 0" style="padding-left: 20px;font-size: 12px;color: red;line-height: 30px;">暂无常用设备</span>
                            <el-option
                              v-else
                              :title="item.deviceCode + '|' + item.label"
                              v-for="item in group.deviceList"
                              :key="item.id"
                              :label="item.operationRatio ? `${item.deviceCode}|${item.label} ${item.operationRatio}` : `${item.deviceCode}|${item.label}`"
                              :value="item.id"
                            >
                              <div :class="{ redText: Number(item.operationRatio) > 1 }" :style="showDeviceStyle">{{ item.deviceCode }}|{{ item.label }}</div>
                              <div :class="{ redText: Number(item.operationRatio) > 1 }" style="float:right;width:50px;text-align: right">{{ Math.round(item.operationRatio * 100) }}%</div>
                            </el-option>
                          </el-option-group>
                        </el-select>
                      </el-col>

                      <el-col :span="5" style="margin-left:4px">
                        <el-select
                          v-model="planItem.deviceTypeId"
                          @change="deviceTypeChange($event, scope, index, planItem)"
                          clearable
                          filterable
                          popper-class="select_width"
                          placeholder="设备类型"
                          :disabled="isDisabled2(scope.row) || planItem.updateFlag == 2"
                        >
                          <el-option :title="item.deviceType" v-for="item in deviceTypeOptions" :key="item.id" :label="item.deviceType" :value="item.id"></el-option>
                        </el-select>
                      </el-col>

                      <el-col :span="4" style="margin-left:4px" class="amount-input">
                        <el-input
                          :class="{ redInput: planItem.unPass }"
                          @input="productionInput(scope.$index, scope.row.groupList, index)"
                          @blur="productionNumChange(scope.$index, scope.row.groupList, index)"
                          v-model="planItem.executeCount"
                          :disabled="isDisabled(scope.row) || planItem.updateFlag == 2"
                        ></el-input>
                      </el-col>

                      <el-col :span="2" style="margin-left:4px">
                        <el-button
                          type="text"
                          @click="deleteItem(scope.row, index, scope.$index)"
                          :disabled="isDisabled(scope.row) || planItem.updateFlag == 2"
                          v-if="scope.row.groupList.length != 1 && planItem.updateFlag == 0"
                          size="small"
                          >删除</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="actualFinishedAmount" label="完工数量" :min-width="W ? 80 : 90">
                <template slot-scope="scope">
                  <div>
                    <el-row v-for="(planItem, index) in scope.row.groupList" :key="index" :style="index != 0 ? { marginTop: '10px' } : {}">
                      <el-col :span="24">
                        <span style="line-height: 32px;">&nbsp; {{ planItem.actualFinishedAmount }}</span>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="theoreticalTime" label="理论时间(s)" :min-width="W ? 80 : 90">
                <template slot-scope="scope">
                  <div>
                    <el-row v-for="(planItem, index) in scope.row.groupList" :key="index" :style="index != 0 ? { marginTop: '10px' } : {}">
                      <el-col :span="24">
                        <span style="line-height: 32px;">&nbsp; {{ parseRunTime(planItem) }}</span>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="remark" label="备注" min-width="70">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" :disabled="isDisabled2(scope.row)"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="remark" label="是否报工" :min-width="W ? 55 : 55">
                <template slot-scope="scope">
                  <el-checkbox @change="needReportStatusChange($event, scope.row)" v-model="scope.row.isNeedReport" :disabled="isDisabled2(scope.row) || cancalSelect(scope.$index)"></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <div :style="W ? { textAlign: 'center', marginTop: '10px' } : { textAlign: 'center', marginTop: '10px', marginBottom: '30px' }">
            <el-button v-if="!arrangeComplete" type="primary" @click="submitProductionPlan(1)">保存</el-button>
            <el-button type="primary" @click="submitProductionPlan(2)">提交</el-button>
          </div>
        </el-row>
      </el-row>
    </el-card>
    <ImportPlanDialog :isShow.sync="showImportPlanView" :targetSplitId="splitId" :technologyId="technologyId" :orderCode="orderCode"></ImportPlanDialog>
  </div>
</template>

<script>
import CommonUtils from "@/util/CommonUtils";
import ImportPlanDialog from "./ImportPlanDialog.vue";
import pinyinMatch from "pinyin-match";
export default {
  name: "OrderItemBaseEdit",
  props: {
    baseData: Object,
    allDeviceListProp: Array,
    allWorkerSelectProp: Array,
    allWorkershopListProp: Array
  },
  components: {
    ImportPlanDialog
  },
  data() {
    return {
      deviceTypeOptions: [],
      factoryModelId: null,
      technologyId: null,
      orderCode: "",
      showImportPlanView: false,
      arrangeComplete: false, //显示保存按钮
      unitType: "",
      needStockAmount: 0,
      hasPlanId: false,
      showTimeChange: true,
      btnTrue: "",
      btnFalse: "",
      splitType: null,
      allStartTime: commonUtils.timestampToDate(this.baseData.planningStartTime, true),
      allEndTime: commonUtils.timestampToDate(this.baseData.planningEndTime, true),
      type: null,
      index: null,
      loading: false,
      W: false,
      dIndex: 0,
      oderType: 0,
      productionType: 0,
      preProductionPlanList: [], //生成计划预安排
      deviceSelect: [], //可用设备
      workerSelect: [], //可用工人
      productionNum: 0,
      workershopList: [],
      allWorkershopList: [],
      allWorkerSelect: [],
      allDeviceList: [],
      fristLoad: false,
      fristEdit: true, //默认第一次编排任务
      splitId: null,
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  beforeMount: async function() {
    this.productionType = this.baseData.productionType || 0;
    this.productionNum = this.baseData.splitCount;
    this.orderCode = this.baseData.orderCode || "";
    this.allDeviceList = commonUtils.cloneObj(this.allDeviceListProp);
    this.allWorkerSelect = commonUtils.cloneObj(this.allWorkerSelectProp);
    this.allWorkershopList = commonUtils.cloneObj(this.allWorkershopListProp);

    this.loadOrderItemPlan();

    this.loadDeviceTypeList();
  },

  //完成挂载
  mounted: function() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    let data = this.baseData;
    this.oderType = data.splitItemType;
    this.spbaseDataData = this.baseData;
    this.needStockAmount = this.baseData.needStockAmount;
    this.unitType = data.unitType || "";
  },

  //更新dom时触发

  computed: {
    showDeviceStyle() {
      if (this.W) {
        return { float: "left", width: "150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
      } else {
        return { float: "left", width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
      }
    },

    showWorkStyle() {
      if (this.W) {
        return { float: "left", width: "80px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
      } else {
        return { float: "left", width: "60px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
      }
    },

    showMaterialName() {
      let data = this.baseData;
      return data.materialName || "";
    },

    showMaterialCode() {
      let data = this.baseData;
      return data.materialCode || "";
    },

    showMaterialModel() {
      let data = this.baseData;
      return data.specification || "";
    },

    showMaterialType() {
      let data = this.baseData;
      let str = "";
      if (data != null) {
        if (data.itemType == 1) {
          str = "零件";
        } else {
          str = "产品";
        }
      }
      return str;
    }
  },

  methods: {
    async loadOrderItemPlan() {
      this.fristLoad = true;
      this.arrangeComplete = this.baseData.arrangeComplete;
      this.productionNum = this.baseData.needAmount;
      let arr = commonUtils.cloneObj(this.baseData.procedureList);
      let dateArr;
      //默认是第一次编排任务
      this.fristEdit = true;
      //当arr中包含有planId的隐藏倒排和顺排
      this.hasPlanId = arr.some(s => s.planId);
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        //兼容groupList不为空
        if (!item.groupList) {
          item.groupList = [{ updateFlag: 0 }];
        }
        //根据工序和类型查询机组下拉数据
        let wokershopRes = await this.loadWorkShopList(item.procedureId, item.factoryModelId);
        if (wokershopRes.length > 1) {
          item.canChangeWokershop = true;
        }
        this.$set(this.workershopList, i, wokershopRes);
        //初始化设备下拉列表
        item.workerSelect = [];
        if (item.groupList.length > 0) {
          item.groupList.forEach(async (p, j) => {
            if (p.workerId || p.deviceId || item.planStartTime || item.planEndTime) {
              let { data } = await this.loadPrduction("", p.workerId, p.deviceId, item.deviceType, item.planStartTime, item.planEndTime, p.groupId);
              p.deviceSelect = data;
            } else {
              p.deviceSelect = commonUtils.cloneObj(this.allDeviceList);
            }

            if (!p.workerId) {
              p.workerSelect = commonUtils.cloneObj(this.allWorkerSelect);
            } else {
              p.workerSelect = await this.loadAllWorkerSelect("", p.workerId, p.groupId);
            }
          });
        }

        item.settedDate = false;
        if (item.groupList.some(g => g.updateFlag == 1)) {
          item.updateFlag = 1;
        }
        if (item.groupList.some(g => g.updateFlag == 2)) {
          item.updateFlag = 2;
          this.fristEdit = false;
        }

        // 已安排生产计划
        if (item.planId != null) {
          //当计划id存在时把默认第一次编辑改为false
          if (this.arrangeComplete) {
            this.fristEdit = false;
          }

          item.planStartTime = commonUtils.timestampToDate(item.planStartTime);
          item.planEndTime = commonUtils.timestampToDate(item.planEndTime);
          if (!item.planStartTime && this.preProductionPlanList[i] && this.preProductionPlanList[i].planStartTime) {
            item.planStartTime = this.preProductionPlanList[i].planStartTime;
            item.planEndTime = this.preProductionPlanList[i].planEndTime;
          }
          if (item.planStartTime && item.planEndTime) {
            arr[i].settedDate = true;
            arr[i].editing = false;
          }
        } else {
          if (!item.planStartTime && this.preProductionPlanList[i] && this.preProductionPlanList[i].planStartTime) {
            item.planStartTime = this.preProductionPlanList[i].planStartTime;
            item.planEndTime = this.preProductionPlanList[i].planEndTime;
          }
        }

        //加载待选这设备和工人
        item.prepareTime = item.prepareTime || item.prepareTime == 0 ? item.prepareTime : 2;
        let len = 1;
        if (item.groupList && item.groupList.length > 0) {
          len = item.groupList.length;
        }
        if (item.productionCycle) {
          item.theoreticalTime = Math.floor((this.productionNum * item.productionCycle) / len) + 3600 * item.prepareTime;
        } else {
          item.theoreticalTime = "";
        }
      }
      //第一次编辑生成默认数据
      if (this.fristEdit) {
        if (!this.arrangeComplete && !arr[0].groupList[0].executeCount) {
          arr.forEach(item => {
            let groupList = item.groupList;
            let svg = this.keepTwoDecimal(this.productionNum / groupList.length);
            let last = this.keepTwoDecimal(this.productionNum - svg * groupList.length);
            groupList.forEach((p, index) => {
              if (index == 0) {
                p.executeCount = this.keepTwoDecimal(svg + last);
              } else {
                p.executeCount = svg;
              }
            });
          });
        }
      }
      //检测是否满足交付日期

      let deliverTime = this.baseData.planningEndTime || new Date(this.baseData.deliverTime).getTime();
      let productionBatchCode = this.baseData.childProductionBatchCode || this.baseData.productionBatchCode;

      if (arr[arr.length - 1].planEndTime) {
        let planEndTime = new Date(arr[arr.length - 1].planEndTime).getTime();
        if (deliverTime && planEndTime > deliverTime) {
          this.$message.warning(`${productionBatchCode}工单排程不满足交期`);
        }
      }

      this.$RequestUtil.loading().close();

      log(99999);
      this.preProductionPlanList = arr;
      // arr.forEach((item,index)=>{
      //     item.groupList.forEach((g,j)=>{
      //         this.$set(this.preProductionPlanList[index].workerSelect, j, g.workerSelect)
      //         // this.$set(this.preProductionPlanList[index].deviceSelect, j, g.deviceSelect)
      //     })
      // })

      this.addDeviceConflictTips();
      this.addWorkerConfictTips();
      log(1000);
    },
    async loadDeviceTypeList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/listDeviceType",
        type: "sync",
        params: {}
      });
      if (code == 0) {
        this.deviceTypeOptions = data;
      } else {
        this.$message.error(msg || message);
      }
    },
    importPlan() {
      this.technologyId = this.baseData.tecId;
      this.splitId = this.baseData.splitId;
      this.showImportPlanView = true;
    },
    factoryModelChange(ev) {
      if (ev) {
        let info = this.allWorkershopList.find(item => item.id == ev) || {};
        this.preProductionPlanList.forEach((item, index) => {
          if (item.canChangeWokershop && item.updateFlag != 2) {
            let find = this.workershopList[index].find(w => w.id == ev);
            this.$set(item, "factoryModelId", Number(ev));
            if (!find) {
              this.workershopList[index].push(info);
            }
          }
        });
      }
    },
    getPlanByTecId(data) {
      let arr = commonUtils.cloneObj(this.preProductionPlanList);
      data.procedureList.forEach((item, index) => {
        arr[index].factoryModelId = item.factoryModelId;
        arr[index].groupList = item.groupList;
      });
      arr.forEach(async (item, index) => {
        let len = 1;
        let groupList = item.groupList;
        let svg = this.keepTwoDecimal(this.productionNum / groupList.length);
        let last = this.keepTwoDecimal(this.productionNum - svg * groupList.length);
        let wokershopRes = await this.loadWorkShopList(item.procedureId, item.factoryModelId);

        this.$set(this.workershopList, index, wokershopRes);

        item.updateFlag = 0;

        if (item.groupList.length > 0) {
          item.groupList.forEach(async (p, j) => {
            if (j == 0) {
              p.executeCount = this.keepTwoDecimal(svg + last);
            } else {
              p.executeCount = svg;
            }

            if (p.qualifiedProcessCount && p.executeCount < p.qualifiedProcessCount) {
              p.unPass = true;
            } else {
              p.unPass = false;
            }

            item.workerSelect = [];
            if (p.workerId || p.deviceId || item.planStartTime || item.planEndTime) {
              let { data } = await this.loadPrduction("", p.workerId, p.deviceId, item.deviceType, item.planStartTime, item.planEndTime, p.groupId);

              p.deviceSelect = data;
            } else {
              p.deviceSelect = commonUtils.cloneObj(this.allDeviceList);
            }

            if (!p.workerId) {
              p.workerSelect = commonUtils.cloneObj(this.allWorkerSelect);
            } else {
              p.workerSelect = await this.loadAllWorkerSelect("", p.workerId, p.groupId);
            }
          });
        }
        item.prepareTime = item.prepareTime || item.prepareTime == 0 ? item.prepareTime : 2;

        if (groupList && groupList.length > 0) {
          len = groupList.length;
        }

        this.$set(this.preProductionPlanList, index, item);
      });
      this.addDeviceConflictTips();
      this.addWorkerConfictTips();
    },

    filterWorkershop(query, index) {
      this.$set(
        this.workershopList,
        index,
        this.allWorkershopList.filter(item => pinyinMatch.match(item.name, query))
      );
    },

    async closeWorkershopSelect(ev, scope) {
      if (!ev) {
        let index = scope.$index;
        let item = scope.row;
        let wokershopRes = await this.loadWorkShopList(item.procedureId, item.factoryModelId);
        this.$set(this.workershopList, index, wokershopRes);
      }
    },

    parseRunTime(rowData) {
      if (rowData.theoreticalTime) {
        return commonUtils.secondToDate(rowData.theoreticalTime);
      } else {
        return "";
      }
    },

    cancalSelect(index) {
      if (index == 0 || index == this.preProductionPlanList.length - 1) {
        return true;
      } else {
        return false;
      }
    },

    hasNeedReport(rowData) {
      return !rowData.isNeedReport;
    },

    needReportStatusChange(ev, rowData) {
      if (ev == false && rowData.groupList.length > 1) {
        this.$confirm("多执行组取消报工后将会删除多执行组数据，是否继续?", "提示", {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(res => {
            let item = rowData.groupList[0];
            item.executeCount = this.productionNum;

            this.$set(rowData, "groupList", [item]);
          })
          .catch(err => {
            this.$set(rowData, "isNeedReport", true);
          });
      }
    },

    productionNumChange(ev, groupList, index) {},

    productionInput(ev, groupList, index) {
      let len = (String(groupList[index].executeCount).split(".")[1] || "").length;
      let executeCount = Number(groupList[index].executeCount);
      if (len > 2) {
        executeCount = Number(executeCount.toFixed(2));
        groupList[index].executeCount = executeCount;
      }
      let qualifiedProcessCount = groupList[index].qualifiedProcessCount;
      if (qualifiedProcessCount && executeCount < qualifiedProcessCount) {
        groupList[index].unPass = true;
      } else {
        groupList[index].unPass = false;
      }
      this.$set(this.preProductionPlanList[ev], "groupList", groupList);
    },

    async reSetDate(params) {
      let { data, code, msg, message } = await this.$RequestUtil.postAsync({ url: "/api/productionPlan/getProcedureTime", type: "sync", params });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    deleteItem(rowData, index, index1) {
      rowData.groupList.splice(index, 1);

      rowData.prepareTime = rowData.prepareTime || rowData.prepareTime == 0 ? rowData.prepareTime : 2;
      if (rowData.productionCycle) {
        rowData.theoreticalTime = Math.floor((this.productionNum * rowData.productionCycle) / rowData.groupList.length) + 3600 * rowData.prepareTime;
      } else {
        rowData.theoreticalTime = "";
      }
      if (this.showTimeChange && rowData.planStartTime && rowData.planId && this.hasPlanId) {
        // this.reSetSelectTime(index1, rowData.planStartTime, 'start')
      }
      let groupList = rowData.groupList;
      let svg = this.keepTwoDecimal(this.productionNum / groupList.length);
      let last = this.keepTwoDecimal(this.productionNum - svg * groupList.length);
      groupList.forEach((item, index) => {
        if (index == 0) {
          item.executeCount = this.keepTwoDecimal(svg + last);
        } else {
          item.executeCount = svg;
        }
        if (item.qualifiedProcessCount && item.executeCount < item.qualifiedProcessCount) {
          item.unPass = true;
        } else {
          item.unPass = false;
        }
      });
    },

    async addSplit(rowData, index) {
      let len = rowData.groupList.length;

      let deviceSelect = [];
      if (rowData.deviceType || rowData.planStartTime || rowData.planEndTime) {
        let { data } = await this.loadPrduction("", "", "", rowData.deviceType, rowData.planStartTime, rowData.planEndTime);

        deviceSelect = data;
      } else {
        deviceSelect = commonUtils.cloneObj(this.allDeviceList);
      }
      rowData.groupList.push({
        updateFlag: 0,
        executeCount: 0,
        factoryModelId: null,
        deviceSelect,
        deviceTypeId: rowData.groupList[0].deviceTypeId,
        workerSelect: commonUtils.cloneObj(this.allWorkerSelect)
      });
      if (this.showTimeChange && rowData.planStartTime && rowData.planId) {
        // this.reSetSelectTime(index, rowData.planStartTime, 'start')
      }
      rowData.prepareTime = rowData.prepareTime || rowData.prepareTime == 0 ? rowData.prepareTime : 2;
      if (rowData.productionCycle) {
        rowData.theoreticalTime = Math.floor((this.productionNum * rowData.productionCycle) / (len + 1)) + 3600 * rowData.prepareTime;
      } else {
        rowData.theoreticalTime = "";
      }
      let groupList = rowData.groupList;
      let svg = this.keepTwoDecimal(this.productionNum / groupList.length);
      let last = this.keepTwoDecimal(this.productionNum - svg * groupList.length);
      groupList.forEach((item, index) => {
        if (index == 0) {
          item.executeCount = this.keepTwoDecimal(svg + last);
        } else {
          item.executeCount = svg;
        }
        if (item.qualifiedProcessCount && item.executeCount < item.qualifiedProcessCount) {
          item.unPass = true;
        } else {
          item.unPass = false;
        }
      });
      this.$set(this.preProductionPlanList, index, rowData);
    },

    keepTwoDecimal(n) {
      n = Number(n);
      return Math.round(n * 100) / 100;
    },

    changeIndex(index, type, dIndex) {
      this.index = index;
      this.type = type;
      this.dIndex = dIndex;
    },

    async deviceBlur(ev, rowData, index, planItem) {
      if (!ev) {
        let workerId = rowData.groupList[index].workerId;
        let deviceId = rowData.groupList[index].deviceId;
        let groupId = rowData.groupList[index].groupId;
        let { data } = await this.loadPrduction("", workerId, deviceId, rowData.deviceType, rowData.planStartTime, rowData.planEndTime, groupId);
        planItem.deviceSelect = data;
        // this.$set(rowData.groupList[index], index, data)
      }
    },

    async remoteMethod(query) {
      this.loading = true;
      let workerId = this.preProductionPlanList[this.index].groupList[this.dIndex].workerId;
      let deviceId = this.preProductionPlanList[this.index].groupList[this.dIndex].deviceId;
      let groupId = this.preProductionPlanList[this.index].groupList[this.dIndex].groupId;
      let planStartTime = this.preProductionPlanList[this.index].planStartTime;
      let planEndTime = this.preProductionPlanList[this.index].planEndTime;
      let deviceType = this.preProductionPlanList[this.index].deviceType;
      let { data } = await this.loadPrduction(query, workerId, deviceId, deviceType, planStartTime, planEndTime, groupId);
      this.$set(this.preProductionPlanList[this.index].groupList[this.dIndex], "deviceSelect", data);
      this.loading = false;
    },

    async remoteMethod1(query) {
      this.loading = true;
      let workerId = this.preProductionPlanList[this.index].groupList[this.dIndex].workerId;
      let groupId = this.preProductionPlanList[this.index].groupList[this.dIndex].groupId;
      let data = await this.loadAllWorkerSelect(query, workerId, groupId);
      this.$set(this.preProductionPlanList[this.index].groupList[this.dIndex], "workerSelect", data);
      this.loading = false;
    },

    async loadPrduction(searchText, userId, deviceId, deviceType, planStartTime, planEndTime, groupId) {
      return await this.$RequestUtil.postAsync({ url: "/api/select/productionAssignableDevice", params: { searchText, userId, deviceId, deviceType, planStartTime, planEndTime, groupId } });
    },

    isDisabled2(row) {
      let flag = false;
      if (row.planId != null && !row.editing) {
        flag = true;
      }
      return flag;
    },

    isDisabled3(row) {
      let flag = false;
      if (row.planId != null && !row.editing) {
        flag = true;
      }
      return flag;
    },

    editPlan(row, index) {
      if (this.preProductionPlanList[index].editing && this.preProductionPlanList[index].settedDate) {
        this.$set(this.preProductionPlanList[index], "editing", false);
      } else {
        this.$set(this.preProductionPlanList[index], "editing", true);
        this.$set(this.preProductionPlanList[index], "settedDate", true);
      }
    },

    isDisabled(row) {
      let flag = false;
      if (row.planId != null && !row.editing) {
        flag = true;
      }
      return flag;
    },

    submit(type) {
      let data = JSON.parse(JSON.stringify(this.preProductionPlanList));
      if (this.btnFalse) {
        if (data[0].planStartTime) {
          let start = new Date(data[0].planStartTime).getTime();
          if (start < new Date().getTime()) {
            this.$message.warning("排程不满足交期");
          }
        }
      } else {
        let deliverTime = this.baseData.planEndTime || this.baseData.deliverTime;
        if (data[data.length - 1].planEndTime) {
          let planEndTime = new Date(data[data.length - 1].planEndTime).getTime();
          if (deliverTime && planEndTime > deliverTime) {
            this.$message.warning("排程不满足交期");
          }
        }
      }

      let submitData = [];
      //默认是提交当有未编排的工序时未保存
      let arrangeComplete = true;
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        // 去除select
        delete item.productionDateTime;
        submitData.push(item);
      }
      if (this.productionType == 1 || this.productionType == 0) {
        //当提交的数据少于加载的数据并且是第一次编辑阻止提交
        if (submitData.length < data.length && this.fristEdit && type == 2) {
          this.$message.error("请填写全部工序计划后提交");
          return;
        }
      }

      //检测有没有选择工人和设备和时间
      let allWorkerIdSelect = true;
      let allDeicIdSelect = true;
      let allTimeSelect = true;
      let allGroupSelect = true;
      let checkProductionNum = true;

      let allSelect = true;
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        if (!item.planEndTime) {
          allTimeSelect = false;
        }
        let count = 0;
        let planItemLen = item.groupList.length;
        for (let index = 0; index < item.groupList.length; index++) {
          const planItem = item.groupList[index];
          delete planItem.deviceSelect;
          planItem.planStartTime = item.planStartTime;
          planItem.planEndTime = item.planEndTime;
          planItem.factoryModelId = item.factoryModelId;
          planItem.executeCount = Number(planItem.executeCount);
          planItem.isNeedReport = item.isNeedReport;
          /*
           * 光明眼镜0527版需求当只有一个执行组时不去校验设备 用户和部门是否填写
           */
          if (planItemLen <= 1) {
            count = planItem.executeCount;
            continue;
          }

          //当工序无法编辑不去校验生产任务数量

          if (isNaN(planItem.executeCount) || planItem.executeCount < 0) {
            this.$message.error({
              type: "error",
              message: `第${i + 1}道工序第${index + 1}个任务生产数量大于零`
            });
            checkProductionNum = false;
            break;
          }
          if (planItem.unPass) {
            this.$message.error({
              type: "error",
              message: `第${i + 1}道工序第${index + 1}个任务生产数量不能小于已报工数量${planItem.qualifiedProcessCount}`
            });
            checkProductionNum = false;
          }
          count += planItem.executeCount;
          //当groupId 存在  workerId 和deviceId需要同时存在或者同时不存在
          if (planItemLen > 1) {
            // if ((!planItem.workerId || !planItem.deviceId)&&type==2 ) {
            //     this.$message.error({
            //         type: 'error',
            //         duration: 3000 + i * 1000,
            //         offset: 20 + i * 50,
            //         message: `第${i + 1}道工序第${index + 1}个任务组执行人和设备不能为空`
            //     })
            //     allSelect = false
            //     // break
            // }
          }
        }

        //检测如果编排任务数量小于生产数量
        if (count < this.productionNum && checkProductionNum && allSelect) {
          this.$message.error({
            type: "error",
            message: `第${i + 1}道工序编排任务生产数量小于订单生产数量`,
            duration: 3000 + i * 1000,
            offset: 20 + i * 50
          });
          checkProductionNum = false;
          break;
        }
        if (count != this.productionNum && checkProductionNum && item.updateFlag != 2) {
          this.$message.error({
            type: "error",
            message: `第${i + 1}道工序编排任务生产数量不等于订单生产数量`,
            duration: 3000 + i * 1000,
            offset: 20 + i * 50
          });
          let pre = this.preProductionPlanList[i];
          let findQualifiedItem = item.groupList.find(item => item.qualifiedProcessCount > 0);
          if (findQualifiedItem) {
            //当执行组中有报工数量，将执行组数量改为报工数量其他设置为空
            item.groupList.forEach((planItem, pIndex) => {
              if (planItem.qualifiedProcessCount) {
                planItem.executeCount = planItem.qualifiedProcessCount;
              } else {
                planItem.executeCount = null;
              }
              pre.groupList[pIndex].executeCount = planItem.executeCount;
            });
          } else {
            //执行组没有报工数量均分填充生产数量
            item.groupList.forEach((planItem, pIndex) => {
              let maxNumber = Math.floor(this.productionNum * 1.1);
              let len = item.groupList.length;
              let svg = this.keepTwoDecimal(this.productionNum / len);
              let remainder = this.keepTwoDecimal(this.productionNum - svg * len);
              if (pIndex == 0) {
                planItem.executeCount = this.keepTwoDecimal(remainder + svg);
              } else {
                planItem.executeCount = svg;
              }
              pre.groupList[pIndex].executeCount = planItem.executeCount;
            });
          }
          checkProductionNum = false;
          break;
        }
      }

      if (!checkProductionNum) {
        return;
      }

      if (!allSelect) {
        return;
      }
      /*
       * 光明眼镜0527版取消编排任务时间必填验证
       */
      // if(!allTimeSelect&&type==2){
      // 	arrangeComplete = false
      // 	this.$message.error('请选择编排时间，编排任务必须选择编排时间')
      // 	return false
      // }

      if (type == 1) {
        arrangeComplete = false;
      } else {
        arrangeComplete = true;
      }

      this.$RequestUtil.post({
        url: "/api/productionPlan/createProductionPlan",
        params: {
          procedureDataList: submitData,
          splitId: this.baseData.splitId,
          productionType: this.productionType,
          arrangeComplete: arrangeComplete,
          tecId: this.baseData.tecId
        },
        type: "sync",
        success: res => {
          if (res.code != 0) {
            this.$message.error(res.message);
            return;
          }
          let str = arrangeComplete ? "生产计划安排完成" : "生产计划保存成功";
          this.$message.success(str);
          this.listPreProductionPlan();
        }
      });
    },

    submitProductionPlan(type) {
      if (type == 2) {
        this.$confirm("是否提交当前编排任务?", "提示", {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.submit(type);
        });
      } else {
        this.submit(type);
      }
    },

    async setDateStart(val, scope) {
      if (scope.row.planEndTime) {
        scope.row.planEndTime = null;
      }
      // scope.row.settedDate = false
      //开始时间被清空时，清除结束时间删除选中的设备和工人并且变成不可编辑
      if (val == null) {
        return;
      }
      if (scope.row.planEndTime) {
        if (new Date(val).getTime() > new Date(scope.row.planEndTime).getTime()) {
          this.$message({ type: "error", message: "起始时间不能大于结束时间" });
          scope.row.planStartTime = "";
        }
      }
      //如果联动编排
      if (this.showTimeChange) {
        // await this.reSetSelectTime(scope.$index, val, 'start')
        // let item = scope.row;
        // this.$nextTick(() => {
        //     item.groupList.forEach(async (p, j) => {
        //         let { data } = await this.loadPrduction('', p.workerId, p.deviceId, item.deviceType, item.planStartTime, item.planEndTime, p.groupId);
        //         this.$set(p,'deviceSelect', data)
        //     })
        // });
      } else {
        this.addDeviceConflictTips();
        this.addWorkerConfictTips();
      }
    },

    async reSetSelectTime(index, val, type) {
      let procedureList = commonUtils.cloneObj(this.preProductionPlanList).splice(index);

      let option = {
        isChangeStartTime: type == "start" ? true : false,
        procedureList
      };
      let date = await this.reSetDate(option);
      if (!date) {
        return;
      }
      let list = date.procedureList;
      list.forEach((item, i) => {
        if (item.planStartTime) {
          if (type == "end" && i == 0) {
            //从结束时间开始修改保持之前的的开始时间
            this.$set(this.preProductionPlanList[i + index], "planStartTime", procedureList[0].planStartTime);
          } else {
            this.$set(this.preProductionPlanList[i + index], "planStartTime", item.planStartTime);
          }
        }
        this.$set(this.preProductionPlanList[i + index], "planEndTime", item.planEndTime);
      });
      log(this.preProductionPlanList, 555);
      this.addDeviceConflictTips();
      this.addWorkerConfictTips();
    },

    async setDateEnd(val, scope) {
      if (val == null) {
        scope.row.planStartTime = "";
        return;
      }
      if (new Date(val).getTime() < new Date(scope.row.planStartTime).getTime()) {
        this.$message({ type: "error", message: "结束时间不能小于起始时间" });
        scope.row.planEndTime = "";
      } else {
        scope.row.settedDate = true;
        scope.row.editing = true;
      }

      let len = this.preProductionPlanList.length - 1;
      if (this.showTimeChange && scope.$index != len) {
        // await this.reSetSelectTime(scope.$index, val, 'end')
        // let item = scope.row;
        // this.$nextTick(() => {
        //     item.groupList.forEach(async (p, j) => {
        //         let { data } = await this.loadPrduction('', p.workerId, p.deviceId, item.deviceType, item.planStartTime, item.planEndTime, p.groupId);
        //         this.$set(p,'deviceSelect', data)
        //     })
        // });
      } else {
        this.addDeviceConflictTips();
        this.addWorkerConfictTips();
      }
    },

    async workerBlur(ev, rowData, index, type) {
      if (!ev) {
        let workerId = rowData.groupList[index].workerId;
        let groupId = rowData.groupList[index].groupId;
        let data = await this.loadAllWorkerSelect("", workerId, groupId);
        this.$set(this.preProductionPlanList[this.index].groupList[index], "workerSelect", data);
        this.loading = false;
      }
    },

    async selectDeviceChange(val, scope, index, planItem) {
      this.addDeviceConflictTips();
      let arr = scope.row.groupList;
      if (!val) {
        let planStartTime = scope.row.planStartTime;
        let planEndTime = scope.row.planEndTime;
        arr[index].operationRatio = 0;
        let { data } = await this.loadPrduction("", arr[index].workerId, arr[index].deviceId, scope.row.deviceType, planStartTime, planEndTime, arr[index].groupId);
        planItem.deviceSelect = data;
      } else {
        let deviceList = planItem.deviceSelect[0].deviceList.concat(planItem.deviceSelect[1].deviceList);
        let deviceTypeId = (deviceList.find(item => item.id == val) || {}).deviceType;
        this.$set(arr[index], "deviceTypeId", deviceTypeId);
      }
      //检测执行人是否存在
      //如果执行人存在 检测是否有相同的设备
      //如果设备相同检测执行人是否相同
      //如果执行人也相同清除当前选中设备

      // if (arr[index].workerId) {
      //     let selectWorker = arr[index].workerId
      //     for (let i = 0; i < arr.length; i++) {
      //         let item = arr[i]
      //         if (i == index) continue;
      //         if (item.deviceId == val && item.workerId == selectWorker) {
      //             this.$message.error('当前设备和执行者重复，请重新选择设备')
      //             // arr[index].deviceId = null
      //             this.$set(arr[index], 'deviceId', null)
      //             arr[index].operationRatio = 0
      //             break
      //         }
      //     }
      // }
    },

    deviceTypeChange(val, scope, index, planItem) {
      //设备id和设备类型同时存在选择的设备类型和设备的类型不一致的话清空设备id
      let arr = scope.row.groupList;
      if (val && arr[index].deviceId) {
        let deviceList = planItem.deviceSelect[0].deviceList.concat(planItem.deviceSelect[1].deviceList);
        let deviceTypeId = (deviceList.find(item => item.id == arr[index].deviceId) || {}).deviceType;
        if (deviceTypeId != val) {
          this.$set(arr[index], "deviceId", null);
        }
      }
    },

    async selectWorkerChange(val, scope, index, planItem) {
      let arr = scope.row.groupList;
      if (!val) {
        arr[index].unFinishedCount = 0;
        arr[index].operationRatio = 0;
        return;
      }

      //检测执行人是否存在
      //如果执行人存在 检测是否有相同的设备
      //如果设备相同检测执行人是否相同
      //如果执行人也相同清除当前选中设备
      let selecDevice = arr[index].deviceId;
      // if (selecDevice) {
      //     for (let i = 0; i < arr.length; i++) {
      //         let item = arr[i]
      //         if (i == index) continue;
      //         if (item.workerId == val && item.deviceId == selecDevice) {
      //             this.$message.error('当前设备和执行者重复，请重新选择用户')
      //             this.$set(arr[index], 'workerId', null)
      //             arr[index].unFinishedCount = 0
      //             break
      //         }
      //     }
      // }
      if (arr[index].deviceId) {
        this.$set(arr[index], "deviceId", null);
        arr[index].operationRatio = 0;
      }
      let planStartTime = scope.row.planStartTime;
      let planEndTime = scope.row.planEndTime;
      let { data } = await this.loadPrduction("", val, arr[index].deviceId, scope.row.deviceType, planStartTime, planEndTime, scope.row.groupId);
      this.$set(planItem, "deviceSelect", data);
      this.addDeviceConflictTips();
    },

    async loadAllWorkerSelect(workerName = "", workerId, groupId) {
      let res = await this.$RequestUtil.getAsync({ url: "/api/select/listWorker", params: { workerName, workerId, groupId, limitCount: 50 } });
      if (res.code == 0) {
        if (!workerName && !workerId && !groupId) {
          this.allWorkerSelect = res.data;
        }
        return res.data;
      }
    },

    async loadWorkShopList(procedureId, id, factoryModelName, factoryModelCode) {
      let res = await this.$RequestUtil.getAsync({ url: "/api/factoryModel/getWorkShopList", params: { itemType: this.baseData.itemType, procedureId, id, factoryModelName, factoryModelCode } });
      if (res.code == 0) {
        return res.data;
      }
    },

    reSet(isAsc) {
      this.$confirm("重新编排计划会清空当前数据,是否重新编排?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (isAsc) {
          this.btnTrue = "primary";
          this.btnFalse = "";
        } else {
          this.btnTrue = "";
          this.btnFalse = "primary";
        }
        this.listPreProductionPlan(isAsc);
      });
    },

    listPreProductionPlan(isAsc) {
      this.$RequestUtil.loading();
      return new Promise((resolve, reject) => {
        this.$RequestUtil.post({
          url: "/api/productionPlan/listPreProductionPlan",
          params: {
            splitId: this.baseData.splitId,
            materialId: this.baseData.materialId,
            productionType: this.productionType,
            tecId: this.baseData.tecId,
            isAsc
          },
          success: async res => {
            if (res.code != 0) {
              this.$message.error(res.message);
              this.$RequestUtil.loading().close();
              reject();
              return;
            }
            this.arrangeComplete = res.data.arrangeComplete;
            let arr = res.data.procedureList;
            let dateArr;
            //默认是第一次编排任务
            this.fristEdit = true;
            //当arr中包含有planId的隐藏倒排和顺排
            this.hasPlanId = arr.some(s => s.planId);
            for (let i = 0; i < arr.length; i++) {
              let item = arr[i];
              //兼容groupList不为空
              if (!item.groupList) {
                item.groupList = [{ updateFlag: 0 }];
              }
              //根据工序和类型查询机组下拉数据
              let wokershopRes = await this.loadWorkShopList(item.procedureId, item.factoryModelId);
              log(wokershopRes, 111);
              this.$set(this.workershopList, i, wokershopRes);
              log(this.workershopList, 2222);
              //初始化设备下拉列表

              if (item.groupList.length > 0) {
                item.groupList.forEach(async (p, j) => {
                  if (p.workerId || p.deviceId || item.planStartTime || item.planEndTime) {
                    let { data } = await this.loadPrduction("", p.workerId, p.deviceId, item.deviceType, item.planStartTime, item.planEndTime, p.groupId);

                    p.deviceSelect = data;
                  } else {
                    p.deviceSelect = commonUtils.cloneObj(this.allDeviceList);
                  }
                  if (!p.workerId) {
                    p.workerSelect = commonUtils.cloneObj(this.allWorkerSelect);
                  } else {
                    p.workerSelect = await this.loadAllWorkerSelect("", p.workerId, p.groupId);
                  }
                });
              }
              item.settedDate = false;
              if (item.groupList.some(g => g.updateFlag == 1)) {
                item.updateFlag = 1;
              }
              if (item.groupList.some(g => g.updateFlag == 2)) {
                item.updateFlag = 2;
                this.fristEdit = false;
              }

              // 已安排生产计划
              if (item.planId != null) {
                //当计划id存在时把默认第一次编辑改为false
                if (this.arrangeComplete) {
                  this.fristEdit = false;
                }

                item.planStartTime = commonUtils.timestampToDate(item.planStartTime);
                item.planEndTime = commonUtils.timestampToDate(item.planEndTime);
                if (item.planStartTime && item.planEndTime) {
                  arr[i].settedDate = true;
                  arr[i].editing = false;
                }
              }

              //加载待选这设备和工人
              item.prepareTime = item.prepareTime || item.prepareTime == 0 ? item.prepareTime : 2;
              let len = 1;
              if (item.groupList && item.groupList.length > 0) {
                len = item.groupList.length;
              }
              if (item.productionCycle) {
                item.theoreticalTime = Math.floor((this.productionNum * item.productionCycle) / len) + 3600 * item.prepareTime;
              } else {
                item.theoreticalTime = "";
              }
            }
            //第一次编辑生成默认数据
            if (this.fristEdit) {
              if (!this.arrangeComplete && !arr[0].groupList[0].executeCount) {
                arr.forEach(item => {
                  let groupList = item.groupList;
                  let svg = this.keepTwoDecimal(this.productionNum / groupList.length);
                  let last = this.keepTwoDecimal(this.productionNum - svg * groupList.length);
                  groupList.forEach((p, index) => {
                    if (index == 0) {
                      p.executeCount = this.keepTwoDecimal(svg + last);
                    } else {
                      p.executeCount = svg;
                    }
                  });
                });
              }
            }
            //检测是否满足交付日期
            let productionBatchCode = this.baseData.childProductionBatchCode || this.baseData.productionBatchCode;
            if (isAsc == true || isAsc == undefined) {
              let deliverTime = this.baseData.planningEndTime || new Date(this.baseData.deliverTime).getTime();

              if (arr[arr.length - 1].planEndTime) {
                let planEndTime = new Date(arr[arr.length - 1].planEndTime).getTime();
                if (deliverTime && planEndTime > deliverTime) {
                  this.$message.warning(`${productionBatchCode}工单排程不满足交期`);
                }
              }
            } else {
              if (arr[0].planStartTime) {
                let start = new Date(arr[0].planStartTime).getTime();
                if (start < new Date().getTime()) {
                  this.$message.warning(`${productionBatchCode}工单排程不满足交期`);
                }
              }
            }
            this.$RequestUtil.loading().close();
            this.preProductionPlanList = arr;
            this.addDeviceConflictTips();
            this.addWorkerConfictTips();
            resolve();
          }
        });
      });
    },

    addWorkerConfictTips() {
      //检测设备冲突添加提示
      let postData = this.preProductionPlanList.map(item => {
        let json = {};
        json.planStartTime = item.planStartTime;
        json.planEndTime = item.planEndTime;
        json.planId = item.planId;
        json.planArray = item.groupList.map(p => {
          let sub = {};
          sub.planId = p.planId;
          sub.workerId = p.workerId;
          return sub;
        });
        return json;
      });
      this.$RequestUtil.post({
        url: "/api/productionPlan/checkWorkerTimeConflict",
        type: "sync",
        params: {
          list: postData
        },
        success: res => {
          if (res.code == 0) {
            let data = res.data;
            data.forEach((item, index) => {
              item.planArray.forEach((sub, subIndex) => {
                let title = "";
                let len = sub.timeArr.length;
                if (len > 0) {
                  title = "时间冲突：";
                  sub.timeArr.forEach((t, index) => {
                    if (index == len - 1) {
                      title += t;
                    } else {
                      title += t + "  ;  ";
                    }
                  });
                }
                this.$set(this.preProductionPlanList[index].groupList[subIndex], "workerTips", title.trim());
              });
            });
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    addDeviceConflictTips() {
      //添加设备时间冲突提示
      let postData = this.preProductionPlanList.map(item => {
        let json = {};
        json.planStartTime = item.planStartTime;
        json.planEndTime = item.planEndTime;
        json.planId = item.planId;
        json.planArray = item.groupList.map(p => {
          let sub = {};
          sub.planId = p.planId;
          sub.deviceId = p.deviceId;
          return sub;
        });
        return json;
      });
      this.$RequestUtil.post({
        url: "/api/productionPlan/checkDeviceTimeConflict",
        type: "sync",
        params: {
          list: postData
        },
        success: res => {
          if (res.code == 0) {
            let data = res.data;
            data.forEach((item, index) => {
              item.planArray.forEach((sub, subIndex) => {
                let title = "";
                let len = sub.timeArr.length;
                if (len > 0) {
                  title = "时间冲突：";
                  sub.timeArr.forEach((t, index) => {
                    if (index == len - 1) {
                      title += t;
                    } else {
                      title += t + "  ;  ";
                    }
                  });
                }
                this.$set(this.preProductionPlanList[index].groupList[subIndex], "deviceTips", title.trim());
              });
            });
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    }
  },
  watch: {
    preProductionPlanList: {
      handler: function(newV) {
        newV.forEach((e, index) => {
          e.groupList.forEach((p, indexP) => {
            if (e.deviceSelect) {
              (e.deviceSelect || []).forEach(s => {
                (s.deviceList || []).forEach(d => {
                  if (p.deviceId === d.id) {
                    p.operationRatio = d.operationRatio;
                  }
                });
              });
            }
            if (p.workerSelect) {
              let find = p.workerSelect.find(w => w.id == p.workerId);
              if (find) {
                p.unFinishedCount = find.unFinishedCount;
              }
            }
          });
        });
      },
      deep: true
    },
    baseData: {
      immediate: true,
      deep: true,
      handler(val) {
        log("检测到数据改变", val, 666);
        if (this.fristLoad) {
          log("执行");
          this.loadOrderItemPlan();
        }
      }
    }
  }
};
</script>

<style scoped>
.operateBtn-wrap {
  margin-top: 20px;
}
.label {
  display: inline-block;

  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}
.value {
  display: inline-block;
  width: 200px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
  vertical-align: top;
}
.help {
  background: url(/static/img/help.png);
  width: 17px;
  height: 17px;
  display: inline-block;
  background-size: cover;
  margin-left: 4px;
  position: relative;
  top: 4px;
}
.file-icon-container {
  width: 36px;
  height: 45px;
  margin-top: -17px;
  background-size: cover;
  position: relative;
  cursor: pointer;
}

.file-delete {
  position: absolute;
  top: -6px;
  left: 28px;
  width: 15px;
  height: 15px;
  background-image: URL("/static/img/delete.png");
  background-size: cover;
  cursor: pointer;
}
@media screen and (max-width: 1366px) {
  .value {
    width: 190px;
  }
  .file-icon-container {
    width: 27px;
    height: 36px;
    margin-top: -10px;
  }
}
@media screen and (max-width: 1280px) {
  .value {
    width: 166px;
  }
}
</style>

<style>
.value .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.select_width {
  width: 139px;
}
.select_width1 {
  width: 250px;
}
.datetime_picker {
  vertical-align: middle;
}
.time_picker .el-time-spinner {
  overflow: hidden;
}
.time_picker .el-time-spinner__wrapper {
  width: 100%;
}
.time_picker .el-time-panel__footer {
  display: flex;
  justify-content: center;
}
.time_picker .el-time-panel {
  width: 150px;
}
.time_picker .el-input__inner {
  text-align: center;
}
.time_picker .el-time-spinner.has-seconds .el-time-spinner__wrapper {
  width: 100%;
}
#orderItemBaseEdit .value .el-input {
  width: 160px;
}
.plan_table .amount-input .el-input .el-input__inner {
  padding: 0px 4px;
}
@media screen and (max-width: 1440px) {
  .plan_table {
    max-height: 500px !important;
    overflow: auto;
  }
  .plan_table .el-table__body-wrapper {
    max-height: 400px !important;
    overflow-y: auto;
  }
}
@media screen and (max-width: 1366px) {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 146px !important;
  }
  #orderItemBaseEdit .value {
    width: 190px;
  }
  #orderItemBaseEdit .value .el-input {
    width: 140px;
  }
  .file-icon-container {
    width: 27px;
    height: 36px;
    margin-top: -10px;
  }
}
@media screen and (max-width: 1280px) {
  .value {
    width: 166px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 140px !important;
  }
}
@media screen and (max-width: 2000px) and (min-width: 1441px) {
  .plan_table {
    max-height: 700px !important;
    overflow: auto;
  }
  .plan_table .el-table__body-wrapper {
    max-height: 600px !important;
    overflow-y: auto;
  }
}
.plan_table .el-select .el-input.is-disabled .el-input__inner {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.redText {
  color: red;
}
.redInput .el-input__inner {
  border: 1px solid red;
}
.redBorder input {
  border-color: red !important;
}
#orderItemBaseEdit .el-select {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/SalesOrder/OrderItemBaseEdit.vue